import { createSlice } from "@reduxjs/toolkit";

const incomingInventorySlice = createSlice({
  name: "incominginventory",
  initialState: {
    //searchResults
    searchResults: [], //List of searched products with added to incoming list and selected variants list status.
    //variantsChosenInSearchResults [Rename]
    variantsChosenInSearchResults: [], //List of variants checked but not added in final incoming variant List
    //variantsSelectedForIncomingInventory [rename]
    variantsSelectedForIncomingInventory: [], // List of variants selected for incoming inventory record creation.
    //displayOnlyShortlistedSearchResults
    displayOnlyShortlistedSearchResults: [], //Temp list of [searchResults] result format with selected products and variants
    searchLoadingStatus: false, //Set status on search API call.
  },
  reducers: {
    addVariantToIncomingInventoryProductsListOnProductLevel(state, action) {
      //Add variant to selected list and update status if variant checked.

      const productObject = action.payload.productObj;
      const existingSearchedProductVariantList = JSON.parse(
        JSON.stringify(state.searchResults)
      );
      const variantsChosenInSearchResults = JSON.parse(
        JSON.stringify(state.variantsChosenInSearchResults)
      );

      const addVariantToSelectedVariantList = (product, variant) => {
        const productObj = {
          product_id: product.product_id,
          variant_id: variant.variant_id,
          reorder_qty: 1,
          image_src: variant.image_src,
          sku: variant.sku,
          product_name: product.product_name,
          variant_name: variant.variant_name,
        };

        updateIsSelectedFromSearchedProductVariantList(product, variant);
        state.variantsChosenInSearchResults.push(productObj);
      };

      const removeVariantToSelectedVariantList = (product, variant) => {
        const selectedProductVariantList = JSON.parse(
          JSON.stringify(state.variantsChosenInSearchResults)
        );

        selectedProductVariantList.splice(
          selectedProductVariantList.findIndex(
            (selectedVariant) =>
              selectedVariant.variant_id === variant.variant_id
          ),
          1
        );

        unSelectIsSelectedFromSearchedProductVariantList(product, variant);
        state.variantsChosenInSearchResults = selectedProductVariantList;
      };

      const unSelectIsSelectedFromSearchedProductVariantList = (
        product,
        variant
      ) => {
        existingSearchedProductVariantList.forEach(function (productObj) {
          if (product.product_id === productObj.product_id) {
            productObj.isSelected = false;
            productObj.product_variants.forEach(function (variantObj) {
              if (variantObj.variant_id === variant.variant_id) {
                variantObj.isSelected = false;
              }
            });
          }

          state.searchResults = existingSearchedProductVariantList;
        });
      };

      const updateIsSelectedFromSearchedProductVariantList = (
        product,
        variant
      ) => {
        existingSearchedProductVariantList.forEach(function (productObj) {
          if (productObj.product_id === product.product_id) {
            let selectedVariantCount = 0;
            productObj.product_variants.forEach(function (variantObj) {
              if (variantObj.variant_id === variant.variant_id) {
                variantObj.isSelected = true;
                selectedVariantCount = selectedVariantCount + 1;
              } else {
                selectedVariantCount = selectedVariantCount + 1;
              }
            });

            if (selectedVariantCount === productObj.product_variants.length) {
              productObj.isSelected = true;
              productObj.isAddedToSelectedList = true;
            }
          }
        });
        state.searchResults = existingSearchedProductVariantList;
      };

      //if is selected is true then remove all variant and set false
      if (productObject.isSelected === true) {
        productObject.product_variants.forEach(function (variant, index) {
          removeVariantToSelectedVariantList(productObject, variant);
        });
      } else {
        //if is selected is false then add all variant and set true

        //if selected variant array is empty then add direactly
        if (variantsChosenInSearchResults.length === 0) {
          productObject.product_variants.forEach(function (variant, index) {
            if (variant.isAddedToTransfer !== true) {
              addVariantToSelectedVariantList(productObject, variant);
            }
          });
        } else {
          productObject.product_variants.forEach(function (variant, index) {
            const isObjectWithIdInArray = variantsChosenInSearchResults.some(
              (obj) => obj.variant_id === variant.variant_id
            );

            if (isObjectWithIdInArray) {
              console.log(`An object with id  exists in the array.`);
            } else {
              console.log(`No object with id exists in the array.`);
              addVariantToSelectedVariantList(productObject, variant);
            }
          });
        }
      }
    },
    addRemoveVariantToIncomingInventoryProductsListOnVarianrLevel(
      state,
      action
    ) {
      //Add variant to selected list and update status if variant checked.

      const productObject = action.payload.productObj;
      const variantObj = action.payload.variantObj;

      const existingSearchedProductVariantList = JSON.parse(
        JSON.stringify(state.searchResults)
      );

      const removeVariantToSelectedVariantList = (product, variant) => {
        const selectedProductVariantList = JSON.parse(
          JSON.stringify(state.variantsChosenInSearchResults)
        );

        selectedProductVariantList.splice(
          selectedProductVariantList.findIndex(
            (selectedVariant) =>
              selectedVariant.variant_id === variant.variant_id
          ),
          1
        );

        unSelectIsSelectedFromSearchedProductVariantList(product, variant);

        state.variantsChosenInSearchResults = selectedProductVariantList;
      };

      const unSelectIsSelectedFromSearchedProductVariantList = (
        product,
        variant
      ) => {
        existingSearchedProductVariantList.forEach(function (productObj) {
          if (product.product_id === productObj.product_id) {
            productObj.isSelected = false;
            productObj.product_variants.forEach(function (variantObj) {
              if (variantObj.variant_id === variant.variant_id) {
                variantObj.isSelected = false;
              }
            });
          }

          state.searchResults = existingSearchedProductVariantList;
        });
      };

      const updateIsSelectedFromSearchedProductVariantList = (
        product,
        variant
      ) => {
        existingSearchedProductVariantList.forEach(function (productObj) {
          if (productObj.product_id === product.product_id) {
            let selectedVariantCount = 0;
            productObj.product_variants.forEach(function (variantObj) {
              if (variantObj.variant_id === variant.variant_id) {
                variantObj.isSelected = true;
                selectedVariantCount = selectedVariantCount + 1;
              } else {
                if (variantObj.isSelected === true) {
                  selectedVariantCount = selectedVariantCount + 1;
                }
              }
            });

            if (selectedVariantCount === productObj.product_variants.length) {
              productObj.isSelected = true;
              productObj.isAddedToSelectedList = true;
            }
          }
        });
        state.searchResults = existingSearchedProductVariantList;
      };

      const addVariantToSelectedVariantList = (product, variant) => {
        const productObj = {
          product_id: product.product_id,
          variant_id: variant.variant_id,
          reorder_qty: 1,
          image_src: variant.image_src,
          sku: variant.sku,
          product_name: product.product_name,
          variant_name: variant.variant_name,
        };

        updateIsSelectedFromSearchedProductVariantList(product, variant);
        state.variantsChosenInSearchResults.push(productObj);
      };

      if (variantObj.isSelected === true) {
        removeVariantToSelectedVariantList(productObject, variantObj);
      } else {
        addVariantToSelectedVariantList(productObject, variantObj);
      }
    },
    setSearchApiLoadingStatus(state, action) {
      //Sets loading status on API getProductVarients service call in actions.
      const searchLoading = action.payload.data;
      state.searchLoadingStatus = searchLoading;
    },
    resetIncomingInventorySelectedProducts(state, action) {
      //reset all list
      state.variantsChosenInSearchResults = [];
      state.variantsSelectedForIncomingInventory = [];
      state.searchResults = [];
    },
    setSearchedProductVariants(state, action) {
      //Get products from search API then compare with selected variant list and transfer list.
      //If variant already added then add already added status for variant.
      //if variant already selected then add selected status for variant object.
      //update the search variant in variant search modal.

      state.searchResults = [];
      const transferVariantsList = state.variantsSelectedForIncomingInventory;
      const searchProductVariantsApiList = action.payload.data;

      const variantsChosenInSearchResults = JSON.parse(
        JSON.stringify(state.variantsChosenInSearchResults)
      );

      const setSelectedVariant = (listVariants) => {
        listVariants.forEach(function (selectedVariantObj) {
          let variantCountTemp = 0;
          searchProductVariantsApiList.forEach(function (product) {
            if (selectedVariantObj.product_id === product.product_id) {
              product.product_variants.forEach(function (variant) {
                if (
                  selectedVariantObj.variant_id === variant.variant_id &&
                  variant.isSelected !== true
                ) {
                  variant.isSelected = true;
                  variantCountTemp = variantCountTemp + 1;
                  if (product.product_variants.length === 1) {
                    product.isSelected = true;
                  }
                } else {
                  variantCountTemp = variantCountTemp + 1;
                }

                if (variant.isSelected === true) {
                  variantCountTemp = variantCountTemp + 1;
                }

                if (variantCountTemp === product.product_variants.length) {
                  product.isSelected = true;
                }
              });
            }
          });
        });

        return searchProductVariantsApiList;
      };

      if (transferVariantsList.length === 0) {
        if (variantsChosenInSearchResults.length > 0) {
          const sevariant = setSelectedVariant(variantsChosenInSearchResults);

          state.searchResults = sevariant;
        } else {
          state.searchResults = searchProductVariantsApiList;
        }
      } else {
        const variantsSelectedForIncomingInventory = JSON.parse(
          JSON.stringify(state.variantsSelectedForIncomingInventory)
        );

        variantsSelectedForIncomingInventory.forEach(function (
          transferVariant
        ) {
          searchProductVariantsApiList.forEach(function (apiProduct) {
            if (apiProduct.product_id === transferVariant.product_id) {
              let vcount = 0;
              apiProduct.product_variants.forEach(function (pvariant) {
                if (pvariant.isAddedToTransfer === true) {
                  vcount = vcount + 1;
                } else {
                  if (pvariant.variant_id === transferVariant.variant_id) {
                    vcount = vcount + 1;
                    pvariant.isAddedToTransfer = true;
                  }
                }
              });
              if (vcount === apiProduct.product_variants.length) {
                apiProduct.isAddedToTransfer = true;
              } else {
                apiProduct.isAddedToTransfer = false;
              }
            }
          });
        });

        const sevariant = setSelectedVariant(variantsChosenInSearchResults);

        state.searchResults = sevariant;
        state.searchLoadingStatus = false;
      }
    },
    addProductVariantsToTransferList(state, action) {
      //Get the selected variants from variantsChosenInSearchResults list.
      //add the variant in variantsSelectedForIncomingInventory and update UI.

      const selectedProductVariantList = JSON.parse(
        JSON.stringify(state.variantsChosenInSearchResults)
      );

      const transferProductVariantList = JSON.parse(
        JSON.stringify(state.variantsSelectedForIncomingInventory)
      );

      if (transferProductVariantList.length > 0) {
        transferProductVariantList.push(...selectedProductVariantList);
        state.variantsSelectedForIncomingInventory = transferProductVariantList;
      } else {
        state.variantsSelectedForIncomingInventory = selectedProductVariantList;
      }

      state.variantsChosenInSearchResults = [];
    },
    removeProductVariantFromTransferList(state, action) {
      //remove variant from incoming variant list.
      // update variantsSelectedForIncomingInventory list
      const removeVariantObj = action.payload;
      const variantsSelectedForIncomingInventory = JSON.parse(
        JSON.stringify(state.variantsSelectedForIncomingInventory)
      );
      const filteredIncomingInventorySelectedTransferProducts =
        variantsSelectedForIncomingInventory.filter(
          (item) => item.variant_id !== removeVariantObj.variant_id
        );

      state.variantsSelectedForIncomingInventory =
        filteredIncomingInventorySelectedTransferProducts;
    },
    updateTransferProductsReorderQuantity(state, action) {
      //Update incoming variant list reorder value onChange vaule
      //variantsSelectedForIncomingInventory List

      const variantsSelectedForIncomingInventory = JSON.parse(
        JSON.stringify(state.variantsSelectedForIncomingInventory)
      );

      const index = action.payload.index;
      const reorderQuantity = action.payload.reorderQuantity;

      variantsSelectedForIncomingInventory[index].reorder_qty = reorderQuantity;

      state.variantsSelectedForIncomingInventory =
        variantsSelectedForIncomingInventory;
    },
    updateOnlySelectedProductVariantList(state, action) {
      // Based on selected variants generate products and variant List.
      // displayOnlyShortlistedSearchResults is view on selected variant section in searched add variant modal.

      const selectedProductVariantList = JSON.parse(
        JSON.stringify(state.variantsChosenInSearchResults)
      );

      let tempArray = [];
      selectedProductVariantList.forEach(function (productObj) {
        if (tempArray.length === 0) {
          const productObjTempp = {
            image_src: productObj.image_src,
            product_id: productObj.product_id,
            product_name: productObj.product_name,
            isSelected: true,
            product_variants: [
              {
                image_src: productObj.image_src,
                sku: productObj.sku,
                variant_name: productObj.variant_name,
                variant_id: productObj.variant_id,
                isSelected: true,
              },
            ],
          };
          tempArray.push(productObjTempp);
        } else {
          const objectIndex = tempArray.findIndex(
            (obj) => obj.product_id === productObj.product_id
          );

          if (objectIndex !== -1) {
            // Object found, update it
            const variant = {
              image_src: productObj.image_src,
              sku: productObj.sku,
              variant_name: productObj.variant_name,
              variant_id: productObj.variant_id,
              isSelected: true,
            };
            tempArray[objectIndex].product_variants.push(variant);
          } else {
            // Object not found, add it to array
            const productObjTempp = {
              image_src: productObj.image_src,
              product_id: productObj.product_id,
              product_name: productObj.product_name,
              isSelected: true,
              product_variants: [
                {
                  image_src: productObj.image_src,
                  sku: productObj.sku,
                  variant_name: productObj.variant_name,
                  variant_id: productObj.variant_id,
                  isSelected: true,
                },
              ],
            };
            tempArray.push(productObjTempp);
          }
        }
      });

      state.displayOnlyShortlistedSearchResults = tempArray;
    },
    mergePickerVariantsIntoIncomingInventory(state, action) {
      /*
       * Add variants chosen in the Shopify admin product picker.
       * A variant that is already in the table keeps its reorder quantity.
       *
       * payload example:
       * [{
       *   product_id: "123",
       *   variant_id: "456",
       *   reorder_qty: 1,
       *   image_src: "https://cdn.shopify.com/variant.jpg",
       *   sku: "TEE-S",
       *   product_name: "Tee",
       *   variant_name: "Small"
       * }]
       */
      const pickedVariants = action.payload || [];

      pickedVariants.forEach(function (picked) {
        const alreadyInTable = state.variantsSelectedForIncomingInventory.some(
          (row) => String(row.variant_id) === String(picked.variant_id)
        );

        if (!alreadyInTable) {
          state.variantsSelectedForIncomingInventory.push(picked);
        }
      });
    },
  },
});

export const incomingInventoryActions = incomingInventorySlice.actions;

export default incomingInventorySlice;
